import { RefObject, useEffect } from 'react'

/**
 * Synchronise le `scrollLeft` d'un élément "source" (qui scrolle horizontalement
 * sous l'action de l'utilisateur) vers un ou plusieurs éléments "cibles"
 * (typiquement un header sticky en `overflow-x: hidden`).
 *
 * Utilisé pour avoir un thead sticky qui suit le scroll horizontal de son tbody
 * sur mobile (cas où position: sticky ne fonctionne pas en vertical à cause
 * d'un parent overflow-x-auto).
 */
export function useHorizontalScrollSync(
  sourceRef: RefObject<HTMLElement | null>,
  targetRefs: Array<RefObject<HTMLElement | null>>,
): void {
  useEffect(() => {
    const source = sourceRef.current
    if (!source) return

    const sync = () => {
      const left = source.scrollLeft
      for (const t of targetRefs) {
        const el = t.current
        if (el && el.scrollLeft !== left) {
          el.scrollLeft = left
        }
      }
    }
    source.addEventListener('scroll', sync, { passive: true })
    // Sync initial au mount
    sync()
    return () => source.removeEventListener('scroll', sync)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
